import { AxisTickProps } from '@nivo/axes'
import { FinancialWorkspaceValueObjectsPeriodEnum } from 'generated/resources/graphql'

import { buildXAxis } from './helpers'

const Tick = (period?: FinancialWorkspaceValueObjectsPeriodEnum, isSmallScreen?: boolean) => {
  const Component = ({
    x,
    y,
    value,
    textX,
    textY,
    tickIndex,
    textAnchor,
  }: AxisTickProps<string>) => {
    if (value === 'Start' || value === 'End') return <tspan />

    if (isSmallScreen && tickIndex % 2 === 0) return <tspan />

    return (
      <g transform={`translate(${x},${y + 8})`}>
        <text
          fill="#515164"
          fontSize="12px"
          textAnchor={textAnchor}
          transform={`translate(${textX},${textY + 10})`}
        >
          <tspan>{buildXAxis(value, period)}</tspan>
        </text>
      </g>
    )
  }

  return Component
}

export { Tick }
